export type Tone = 'blue' | 'cyan' | 'emerald' | 'amber' | 'red' | 'violet' | 'slate';

export const axiomTheme = {
  color: {
    background: '#020617',
    canvas: '#0f172a',
    canvasElevated: '#111c2f',
    panel: '#0b1220',
    panelMuted: '#162033',
    text: {
      primary: '#f8fafc',
      secondary: '#cbd5e1',
      muted: '#94a3b8',
      faint: '#64748b',
      inverse: '#020617',
    },
    border: {
      subtle: 'rgba(148, 163, 184, 0.12)',
      default: 'rgba(148, 163, 184, 0.18)',
      strong: 'rgba(148, 163, 184, 0.28)',
      focus: 'rgba(56, 189, 248, 0.55)',
    },
    tone: {
      blue: '#60a5fa',
      cyan: '#38bdf8',
      emerald: '#34d399',
      amber: '#fbbf24',
      red: '#f87171',
      violet: '#a78bfa',
      slate: '#94a3b8',
    } satisfies Record<Tone, string>,
  },
  radius: {
    xs: '6px',
    sm: '8px',
    md: '10px',
    lg: '12px',
    xl: '14px',
    xxl: '18px',
    hero: '20px',
    pill: '999px',
  },
  spacing: {
    page: '1.5rem',
    panel: '1rem',
    card: '0.85rem',
  },
  typography: {
    eyebrow: {
      size: '0.68rem',
      weight: 800,
      tracking: '0.16em',
    },
    label: {
      size: '0.65rem',
      weight: 850,
      tracking: '0.1em',
    },
    body: {
      size: '0.78rem',
      lineHeight: 1.45,
    },
  },
  shadow: {
    panel: '0 16px 42px rgba(2, 6, 23, 0.28)',
    drawer: '0 24px 80px rgba(2, 6, 23, 0.5)',
    focus: '0 0 0 3px rgba(56, 189, 248, 0.18)',
  },
  surface: {
    hero: `
      radial-gradient(circle at top left, rgba(56, 189, 248, 0.10), transparent 34%),
      linear-gradient(135deg, rgba(15, 23, 42, 0.94), rgba(2, 6, 23, 0.9))
    `,
    panel: 'rgba(2, 6, 23, 0.34)',
    panelHeader: 'linear-gradient(180deg, rgba(15, 23, 42, 0.78), rgba(15, 23, 42, 0.42))',
    rail: 'rgba(15, 23, 42, 0.62)',
    card: 'rgba(15, 23, 42, 0.68)',
    cardMuted: 'rgba(15, 23, 42, 0.48)',
    input: 'rgba(2, 6, 23, 0.38)',
  },
} as const;

export const toneColor = (tone: Tone = 'blue') => axiomTheme.color.tone[tone];

export const toneAlpha = (tone: Tone = 'blue', alphaHex: string) => `${toneColor(tone)}${alphaHex}`;

